import { useState } from "react";

import type { Note, UUID } from "@/core/types";
import type { NoteHistoryViewAs } from "@/features/cosignature/types";

import { NoteCosignHistoryModal } from "./components/CosignHistoryModal";
import { NoteListItem } from "./components/NoteListItem";

type HistoryState = { isOpen: boolean; note: Note | undefined };

type Props = {
  notes: Note[] | undefined;
  onToggleNote: (id: UUID) => void;
  onViewNote: (note: Note) => void;
  selectedNoteIds: Set<UUID>;
  viewAs: NoteHistoryViewAs;
};

export function NoteList({ notes, onToggleNote, onViewNote, selectedNoteIds, viewAs }: Props) {
  const [history, setHistory] = useState<HistoryState>({ isOpen: false, note: undefined });

  return (
    <>
      <ul className="tw:flex tw:flex-col tw:gap-5">
        {notes?.map((note) => (
          <NoteListItem
            isSelectedForExport={selectedNoteIds.has(note.id)}
            key={note.id}
            note={note}
            onToggleSelection={() => onToggleNote(note.id)}
            onView={() => onViewNote(note)}
            onViewCosignHistory={() => setHistory({ isOpen: true, note })}
          />
        ))}
      </ul>

      <NoteCosignHistoryModal
        isOpen={history.isOpen}
        note={history.note}
        onClose={() => setHistory((prev) => ({ ...prev, isOpen: false }))}
        viewAs={viewAs}
      />
    </>
  );
}
